module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-kz-d0b07b30945d9f5b5949517880cb0418.png";